<template>
	<div>

		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_1 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>

		<div class="tour-step-21">
			<template v-if="!isCoordinatore">
				<v-row v-if="isAccountManager">
					<v-col class="d-flex justify-end mb-3">
						<v-btn
							color="secondary"
							@click="downloadAllFiles()"
							:disabled="isLoading || nessunFileCaricato"
						>
							{{ nessunFileCaricato ? 'Nessun documento caricato' : 'Scarica tutti i documenti' }}
						</v-btn>
					</v-col>
				</v-row>

				<div
					:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"
					class="mt-5 mb-8"
				></div>

				<v-row>
					<v-col>
						<div>
							<p>
								Carica nel riquadro qui in basso il <b>Contratto di Servizio che hai firmato con noi</b>. Se non lo hai ancora firmato, ti invitiamo a farlo il prima possibile, una copia del contratto ti è stata inviata tramite email dal nostro commerciale.
							</p>
							<p>
								Se hai firmato con noi un Accordo di Prenotazione <b>carica qui solo il Contratto di Servizio e non l'Accordo</b> che invece puoi già trovare nella sezione "Materiale informativo" in alto nel menù.
							</p>
							<p
								v-if="pratica.accordo.cliente.tipologia != 'Azienda'"
								class="mb-0"
							>
								⚠️ NOTA BENE: Se sei un consulente e hai un unico contratto di servizio per più pratiche, devi caricare quel singolo contratto solo nella prima pratica (seleziona l’Opzione 1 qui sotto).<br>
								Poi nelle altre pratiche lo devi selezionare dal menù a tendina, senza caricarlo di nuovo (seleziona l’Opzione 2 qui sotto).<br>
								Ti preghiamo di fare attenzione a <b>non caricare mai due volte lo stesso contratto su più pratiche</b>.
							</p>

						</div>

						<v-radio-group
							v-if="pratica.accordo.cliente.tipologia != 'Azienda'"
							v-model="contrattoDiServizioOption"
							hide-details
							:readonly="action == 'show'"
							:disabled="isLoading || tourIsRunning || pratica.idPraticaConContrattoDiServizio !== null || files.contratto_di_servizio !== null"
							class="mt-0"

						>
							<v-radio
								label="Opzione 1: Questa pratica è associata a un nuovo contratto che stai caricando per la prima volta"
								value="option_1"
								class="mb-1"
							></v-radio>
							<v-radio
								label="Opzione 2: Questa pratica è associata a un contratto che hai già caricato precedentemente"
								value="option_2"
							></v-radio>
						</v-radio-group>
					</v-col>
				</v-row>

				<v-row
					v-if="canIShowContrattoDiServizioFileInput"
				>
					<v-col>
						<!-- TODO: al momento l'eliminazione del contratto di servizio non è gestita per varie necessità -->
						<v-badge
							:value="haveFilesBeenModified.contratto_di_servizio"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-file-input
								v-model="files.contratto_di_servizio"
								label="Contratto di servizio"
								outlined
								dense
								clearable
								hide-details
								accept=".pdf"
								truncate-length="120"
								@change="setFileChanged(files.contratto_di_servizio)"
								@click:clear="onContrattoDiServizioClear()"
								:loading="isLoadingContrattoDiServizio"
								:disabled="isLoading || tourIsRunning"
							>
								<template
									v-slot:append
								>
									<template v-if="pratica.contratto_di_servizio.path_contratto_di_servizio !== null && !isLoadingContrattoDiServizio">
										<v-progress-circular
											v-if="downloadingContrattoDiServizio"
											size="24"
											width="3"
											color="primary"
											indeterminate
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="download(pratica.contratto_di_servizio.path_contratto_di_servizio, 'contratto_di_servizio')"
										>
											mdi-tray-arrow-down
										</v-icon>
									</template>
									<v-icon
										v-if="files.contratto_di_servizio !== null"
										class="ml-3"
										@click="viewFileInBrowser(files.contratto_di_servizio)"
									>
										mdi-eye-outline
									</v-icon>
								</template>
							</v-file-input>
						</v-badge>
					</v-col>
				</v-row>
				<v-row v-else-if="action == 'show' || (isCliente && pratica.id_stato_fase_1 == 118)">
					<v-col>
						<v-text-field
							:value="getFileNameFromPath(pratica.contratto_di_servizio.path_contratto_di_servizio)"
							label="Contratto di servizio"
							outlined
							dense
							readonly
						>
							<template
								v-slot:append
								v-if="pratica.contratto_di_servizio.path_contratto_di_servizio !== null && !isCoordinatore"
							>
								<template>
									<v-progress-circular
										v-if="downloadingContrattoDiServizio"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.contratto_di_servizio.path_contratto_di_servizio, 'contratto_di_servizio')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
								<template>
									<v-progress-circular
										v-if="isGettingFile.contratto_di_servizio"
										size="24"
										width="3"
										color="primary"
										indeterminate
										class="ml-3"
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="getFileAndViewInBrowser(pratica.path_modulo_riepilogo, 'contratto_di_servizio')"
									>
										mdi-eye-outline
									</v-icon>
								</template>
							</template>
						</v-text-field>
					</v-col>
				</v-row>

				<v-row v-if="contrattoDiServizioOption == 'option_2'">
					<v-col>
						<!--:value="praticaDiff.includes('contratto_di_servizio_id')"-->
						<v-badge
							:value="praticaDiff.includes('idPraticaConContrattoDiServizio')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-autocomplete
								:items="praticheConContrattiDiServizio"
								v-model="pratica.idPraticaConContrattoDiServizio"
								:loading="isLoadingPraticheConContrattiDiServizio"
								label="Scegli un Contratto di servizio già associato ad una pratica"
								item-value="id"
								item-text="nome_file_custom_id"
								outlined
								dense
								clearable
								:disabled="isLoading || tourIsRunning || (isCliente && pratica.id_stato_fase_1 == 118)"
							></v-autocomplete>
						</v-badge>
					</v-col>
				</v-row>

				<div
					:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"
					class="mt-5 mb-8"
				></div>
			</template>

			<v-row class="mb-2">
				<v-col>
					<div class="mb-4">
						Carica il <b>Modulo di Riepilogo</b> in formato PDF cliccando sul riquadro qui in basso.
            Sarà <b>disponibile dopo che avrai completato la compilazione della domanda sul sito INAIL</b>.
            Inviaci questo modulo <b>senza effettuare alcuna modifica o spostamento dei dati</b>,
            per minimizzare il rischio di generare errori che potrebbero compromettere le successive
            fasi di invio della domanda e quindi del ricevimento dei fondi.
					</div>

					<template v-if="action == 'store' || (action == 'edit' && ((isCliente && pratica.id_stato_fase_1 != 118) || isAccountManager))">
						<v-badge
							:value="haveFilesBeenModified.modulo_riepilogo"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-file-input
								v-model="files.modulo_riepilogo"
								label="Modulo di Riepilogo"
								hide-details
								outlined
								dense
								clearable
								accept=".pdf"
								truncate-length="120"
								@change="setFileChanged(files.modulo_riepilogo)"
								@click:clear="pratica.path_modulo_riepilogo = null"
								:loading="isLoadingModuloRiepilogo"
								:disabled="isLoading || tourIsRunning"
							>
								<template
									v-slot:append
								>
									<template v-if="pratica.path_modulo_riepilogo !== null && !isLoadingModuloRiepilogo">
										<v-progress-circular
											v-if="downloadingModuloRiepilogo"
											size="24"
											width="3"
											color="primary"
											indeterminate
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="download(pratica.path_modulo_riepilogo, 'modulo_riepilogo')"
										>
											mdi-tray-arrow-down
										</v-icon>
									</template>
									<v-icon
										v-if="files.modulo_riepilogo !== null"
										class="ml-3"
										@click="viewFileInBrowser(files.modulo_riepilogo)"
									>
										mdi-eye-outline
									</v-icon>
								</template>
							</v-file-input>
						</v-badge>
					</template>
					<template v-else-if="action == 'show' || isCoordinatore || (isCliente && pratica.id_stato_fase_1 == 118)">
						<v-text-field
							:value="getFileNameFromPath(pratica.path_modulo_riepilogo)"
							label="Modulo di Riepilogo"
							hide-details
							outlined
							dense
							readonly
						>
							<template
								v-slot:append
								v-if="pratica.path_modulo_riepilogo !== null && !isCoordinatore"
							>
								<template>
									<v-progress-circular
										v-if="downloadingModuloRiepilogo"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.path_modulo_riepilogo, 'modulo_riepilogo')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
								<template>
									<v-progress-circular
										v-if="isGettingFile.modulo_riepilogo"
										size="24"
										width="3"
										color="primary"
										indeterminate
										class="ml-3"
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="getFileAndViewInBrowser(pratica.path_modulo_riepilogo, 'modulo_riepilogo')"
									>
										mdi-eye-outline
									</v-icon>
								</template>
							</template>
						</v-text-field>
					</template>

          <v-btn
            v-if="pratica.path_modulo_riepilogo !== null && isAccountManager && action == 'edit'"
            @click="estraiESalvaDatiDalModuloDiRiepilogoSulDB(pratica.id, pratica.path_modulo_riepilogo)"
            :loading="isLoadingeEstraiESalvaDatiDalModuloDiRiepilogoSulDB"
            color="secondary"
            :disabled="isLoading"
            class="mt-3"
          >
            Estrai e salva nella Pratica i dati dal Modulo di Riepilogo
          </v-btn>
				</v-col>
			</v-row>

			<div
				:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"
				class="mt-5 mb-8"
			></div>

			<v-row class="mb-2">
				<v-col>
					<div class="mb-4">
						Carica anche il <b>Modulo Codice Click Day in formato PDF</b> cliccando sul riquadro in basso.<br>
						Questo modulo in formato PDF contiene il <b>codice identificativo</b> assegnato all'azienda dall'INAIL, ed è <b>disponibile sul portale INAIL a partire dal 3 giugno</b>.<br>
						Inviaci questo modulo <b>senza effettuare alcuna modifica o spostamento dei dati</b>, per minimizzare il rischio di generare errori che potrebbero compromettere le successive fasi di invio della domanda e quindi del ricevimento dei fondi.
					</div>

					<template v-if="action == 'store' || (action == 'edit' && ((isCliente && pratica.id_stato_fase_1 != 118) || isAccountManager))">
						<v-badge
							:value="haveFilesBeenModified.modulo_codice_clickday"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-file-input
								v-model="files.modulo_codice_clickday"
								label="Modulo Codice Click Day"
								hide-details
								outlined
								dense
								clearable
								accept=".pdf"
								truncate-length="120"
								@change="setFileChanged(files.modulo_codice_clickday)"
								@click:clear="pratica.path_modulo_codice_clickday = null"
								:loading="isLoadingModuloCodiceClickday"
								:disabled="isLoading || tourIsRunning"
							>
								<template
									v-slot:append
								>
									<template v-if="pratica.path_modulo_codice_clickday !== null && !isLoadingModuloCodiceClickday">
										<v-progress-circular
											v-if="downloadingModuloCodiceClickday"
											size="24"
											width="3"
											color="primary"
											indeterminate
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="download(pratica.path_modulo_codice_clickday, 'modulo_codice_clickday')"
										>
											mdi-tray-arrow-down
										</v-icon>
									</template>

									<v-icon
										v-if="files.modulo_codice_clickday !== null"
										class="ml-3"
										@click="viewFileInBrowser(files.modulo_codice_clickday)"
									>
										mdi-eye-outline
									</v-icon>
								</template>
							</v-file-input>
						</v-badge>
					</template>
					<template v-else-if="action == 'show' || isCoordinatore || (isCliente && pratica.id_stato_fase_1 == 118)">
						<v-text-field
							:value="getFileNameFromPath(pratica.path_modulo_codice_clickday)"
							label="Modulo Codice Click Day"
							hide-details
							outlined
							dense
							readonly
						>
							<template
								v-slot:append
								v-if="pratica.path_modulo_codice_clickday !== null && !isCoordinatore"
							>
								<template>
									<v-progress-circular
										v-if="downloadingModuloCodiceClickday"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.path_modulo_codice_clickday, 'modulo_codice_clickday')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>

								<template>
									<v-progress-circular
										v-if="isGettingFile.modulo_codice_clickday"
										size="24"
										width="3"
										color="primary"
										indeterminate
										class="ml-3"
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="getFileAndViewInBrowser(pratica.path_modulo_codice_clickday, 'modulo_codice_clickday')"
									>
										mdi-eye-outline
									</v-icon>
								</template>
							</template>
						</v-text-field>
					</template>

          <v-btn
            v-if="pratica.path_modulo_codice_clickday !== null && isAccountManager && action == 'edit'"
            @click="estraiESalvaCodiceIdentificativoDalModuloCodiceClickdaySulDB(pratica.id, pratica.path_modulo_codice_clickday)"
            :loading="isLoadingeEstraiESalvaCodiceIdentificativoDalModuloCodiceClickdaySulDB"
            color="secondary"
            :disabled="isLoading"
            class="mt-3"
          >
            Estrai e salva nella Pratica il Codice Identificativo dal Modulo Codice Click Day
          </v-btn>
				</v-col>
			</v-row>

			<div
				:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"
				class="mt-5 mb-8"
			></div>

			<!--<v-sheet-->
			<!--	rounded-->
			<!--	color="primary"-->
			<!--	class="my-5 px-4 text-h6 tertiary&#45;&#45;text"-->
			<!--&gt;-->
			<!--	Dati utili-->
			<!--</v-sheet>-->

			<v-row>
				<v-col>
					Inserisci nello spazio in basso la <b>PEC primaria associata alla domanda</b> che puoi trovare nella prima pagina del Modulo di Riepilogo, vicino alla voce "<b>E-mail (PEC) dell'azienda</b>". Per sapere perché ti chiediamo la PEC leggi questo articolo: <a href="https://clickday.it/pec-abilitata/" target="_blank">https://clickday.it/pec-abilitata/</a>
				</v-col>
			</v-row>
			<v-row class="mt-0">
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('pec')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.pec"
							@input="pratica.pec = $event !== '' ? $event : null"
							label="PEC primaria dell'azienda associata alla domanda"
							outlined
							dense
							:readonly="(isCliente && pratica.id_stato_fase_1 == 118) || isCoordinatore || action == 'show'"
							:disabled="tourIsRunning"
							:rules="[mixin_rules.email]"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>

			<v-row class="mt-0">
				<v-col class="d-flex align-center">
					<div class="mr-3">
						La PEC primaria dell'azienda associata alla domanda è abilitata a ricevere email ordinarie (ovvero non PEC)?
					</div>
					<v-badge
						:value="praticaDiff.includes('is_pec_abilitata')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-radio-group
							v-model="pratica.is_pec_abilitata"
							class="mt-0"
							row
							hide-details
							:readonly="(isCliente && pratica.id_stato_fase_1 == 118) || isCoordinatore || action == 'show'"
							:disabled="tourIsRunning"
						>
							<v-radio
								label="Si"
								:value="true"
							></v-radio>
							<v-radio
								label="No"
								:value="false"
							></v-radio>
						</v-radio-group>
					</v-badge>
				</v-col>
			</v-row>

			<v-row class="mt-0">
				<v-col >
					Se non sei sicuro se la <b>PEC primaria sia abilitata</b> alla ricezione di email ordinarie, ti invitiamo a leggere il nostro articolo:: <a href="https://clickday.it/pec-abilitata/" target="_blank">https://clickday.it/pec-abilitata/</a>
				</v-col>
			</v-row>

			<div
				:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"
				class="mt-5 mb-8"
			></div>

			<v-row class="mt-6">
				<v-col>
					Infine inserisci in basso un <b>numero di telefono che deve appartenere alla persona responsabile della pratica</b> che ha a disposizione tutte le informazioni sul progetto e sull’azienda che sta partecipando al Click Day e <b>DEVE essere reperibile il giorno e nella fascia oraria del Click Day</b>.
					Verrà contattato solo nell’improbabile caso in cui le informazioni a nostra disposizione non fossero sufficienti a rispondere alle domande integrative richieste dalla procedura di invio della domanda il giorno del Click Day. Consigliamo di inserire un <b>numero di cellulare</b> o in alternativa un numero fisso (<b>no centralino</b>).

				</v-col>
			</v-row>
			<v-row class="mt-0">
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('numero_di_emergenza')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.numero_di_emergenza"
							@input="pratica.numero_di_emergenza = $event !== '' ? $event : null"
							label="Numero di emergenza"
							outlined
							dense
							:readonly="(isCliente && pratica.id_stato_fase_1 == 118) || isCoordinatore || action == 'show'"
							:disabled="tourIsRunning"
							:rules="[mixin_rules.numero_di_emergenza]"
						>
							<template v-slot:append>
								<v-tooltip
									bottom
									color="primary"
								>
									<template v-slot:activator="{ on }">
										<v-icon v-on="on">
											mdi-help-circle-outline
										</v-icon>
									</template>
									Nel caso si volessero inserire più numeri di emergenza separarli con un trattino (-)
								</v-tooltip>
							</template>
						</v-text-field>
					</v-badge>
				</v-col>
			</v-row>

			<!--<v-row class="mt-0">-->
			<!--	<v-col>-->
			<!--		Questo numero deve appartenere alla persona che ha a disposizione tutte le informazioni sull’azienda che sta partecipando al Click Day e DEVE essere reperibile il giorno e nella fascia oraria del Click Day.<br>-->
			<!--		Verrà contattato solo nell’improbabile caso in cui le informazioni a nostra disposizione non fossero sufficienti a rispondere alle domande integrative richieste dalla procedura di invio della domanda il giorno del Click Day.-->
			<!--	</v-col>-->
			<!--</v-row>-->

		</div>

		<v-dialog v-model="dialogDuplicatoPartitaIva" max-width="550" persistent>
			<v-card>
				<v-card-title class="text-h6">
					Attenzione: Partita IVA / Codice Fiscale duplicato
				</v-card-title>
				<v-card-text>
					La Partita IVA / Codice Fiscale <b>{{ duplicatoPartitaIvaInfo.partita_iva_codice_fiscale }}</b> è già presente nelle seguenti altre pratiche di questo bando:
					<ul class="mt-2">
						<li v-for="customId in duplicatoPartitaIvaInfo.custom_ids_pratiche_duplicate" :key="customId">
							<b>{{ customId }}</b>
						</li>
					</ul>
					<br>
					Vuoi continuare comunque con l'estrazione ed il salvataggio dei dati?
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
            @click="dialogDuplicatoPartitaIva = false"
            color="tertiary"
            class="black--text"
          >
						Annulla
					</v-btn>
					<v-btn color="secondary" @click="confermaEstrazioneDatiModuloRiepilogo">
						Continua
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
const mime = require('mime');
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff', 'haveFilesBeenModified'],
	data() {
		return {
			isSettingPratica: false,
			pratica: {
				id: null,
				accordo_id: null,
				id_stato_fase_1: null,
				ci_sono_aggiornamenti_fase_1: false,
				pec: null,
				is_pec_abilitata: null,
				numero_di_emergenza: null,
				priorita: null,
				path_modulo_codice_clickday: null,
				path_modulo_riepilogo: null,
				contratto_di_servizio_id: null,
				contratto_di_servizio: {
					id: null,
					path_contratto_di_servizio: null
				},
				idPraticaConContrattoDiServizio: null // dato extra aggiunto
			},
			files: {
				modulo_codice_clickday: null,
				modulo_riepilogo: null,
				contratto_di_servizio: null
			},
			isLoadingModuloCodiceClickday: false,
			isLoadingModuloRiepilogo: false,
			isLoadingContrattoDiServizio: false,

			praticheConContrattiDiServizio: [],
			isLoadingPraticheConContrattiDiServizio: false,

			downloadingModuloCodiceClickday: false,
			downloadingModuloRiepilogo: false,
			downloadingContrattoDiServizio: false,

			contrattoDiServizioOption: null,

      isLoadingeEstraiESalvaDatiDalModuloDiRiepilogoSulDB: false,
      isLoadingeEstraiESalvaCodiceIdentificativoDalModuloCodiceClickdaySulDB: false,

      dialogDuplicatoPartitaIva: false,
      duplicatoPartitaIvaInfo: {
        partita_iva_codice_fiscale: null,
        custom_ids_pratiche_duplicate: []
      },
      praticaIdInAttesaDiConfermaEstrazione: null,
      pathModuloRiepilogoInAttesaDiConfermaEstrazione: null
		}
	},

	created() {
		this.isSettingPratica = true;
		this.pratica = this.value;
		this.isSettingPratica = false;

		// aggiorno sul db
		if (this.pratica.ci_sono_aggiornamenti_fase_1 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_1 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_1',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_1');
		}

		if (this.pratica.ci_sono_aggiornamenti_per_account_manager_fase_1 && this.isAccountManager) {
			this.pratica.ci_sono_aggiornamenti_per_account_manager_fase_1 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_per_account_manager_fase_1',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_per_account_manager_fase_1');
		}

		if (this.pratica.path_modulo_codice_clickday !== null && ((this.action != 'show' && this.isAccountManager) || this.isCliente)) {
			this.getModuloCodiceClickday();
		}

		if (this.pratica.path_modulo_riepilogo !== null && ((this.action != 'show' && this.isAccountManager) || this.isCliente)) {
			this.getModuloRiepilogativoClickDay();
		}

		if (this.pratica.contratto_di_servizio.path_contratto_di_servizio !== null && ((this.action != 'show' && this.isAccountManager) || this.isCliente)) {
			this.getContrattoDiServizio();
		}

		this.getPraticheConContrattoDiServizio();
	},

	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isAzienda: 'auth/isAzienda',
			isCoordinatore: 'auth/isCoordinatore',
			tourIsRunning: 'tour/isRunning'
		}),
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingModuloCodiceClickday
				|| this.isLoadingModuloRiepilogo
				|| this.isLoadingContrattoDiServizio
				|| this.isLoadingPraticheConContrattiDiServizio;
		},
		nessunFileCaricato() {
			return this.pratica.path_modulo_codice_clickday === null
				&& this.pratica.path_modulo_riepilogo === null
				&& this.pratica.contratto_di_servizio.path_contratto_di_servizio === null;
		},
		// TODO: semplificare/ordinare la logica di questo metodo...
		canIShowContrattoDiServizioFileInput() {
			return this.action == 'store'
				|| (
					this.action == 'edit' // i clienti agiscono sempre in edit
					&& (
						(
							this.isCliente
							&& this.pratica.id_stato_fase_1 != 118
							&& (
								(
									(
										this.contrattoDiServizioOption == 'option_1'
										|| this.files.contratto_di_servizio !== null
									)
									&& !this.isAzienda
								)
								|| this.isAzienda
							)
						)
						|| (
							this.isAccountManager
							&& (
								this.contrattoDiServizioOption == 'option_1' // selezionabile solo se la pratica non è di un'azienda singola
								|| this.files.contratto_di_servizio !== null
							)
							|| this.pratica.accordo.cliente.tipologia == 'Azienda'
						)
					)
				)
		}
	},

	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica);
				}
			},
			deep: true
		},
		files: {
			handler(newFiles) {
				if (!this.isLoading) {
					this.$emit('update-files', newFiles)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		}
	},

	methods: {
		async getModuloCodiceClickday() {
			this.isLoadingModuloCodiceClickday = true;
			this.files.modulo_codice_clickday = await this.getFile(this.pratica.path_modulo_codice_clickday);
			this.files.modulo_codice_clickday.changed = false;
			this.isLoadingModuloCodiceClickday = false;
		},
		async getModuloRiepilogativoClickDay() {
			this.isLoadingModuloRiepilogo = true;
			this.files.modulo_riepilogo = await this.getFile(this.pratica.path_modulo_riepilogo);
			this.files.modulo_riepilogo.changed = false;
			this.isLoadingModuloRiepilogo = false;
		},
		async getContrattoDiServizio() {
			this.isLoadingContrattoDiServizio = true;
			this.files.contratto_di_servizio = await this.getFile(this.pratica.contratto_di_servizio.path_contratto_di_servizio);
			this.files.contratto_di_servizio.changed = false;
			this.isLoadingContrattoDiServizio = false;
		},
		getPraticheConContrattoDiServizio() {
			this.isLoadingPraticheConContrattiDiServizio = true;
			axios.get(`/api/pratiche?pratiche_con_contratto_di_servizio=true&accordo_id=${this.pratica.accordo_id}`)
				.then(response => {
					this.praticheConContrattiDiServizio = response.data;
				})
				.finally(() => {
					this.isLoadingPraticheConContrattiDiServizio = false;
				})
		},
		download(path, key) {
			const fileName = this.getFileNameFromPath(path);
			if (key == 'modulo_codice_clickday') this.downloadingModuloCodiceClickday = true;
			else if (key == 'modulo_riepilogo') this.downloadingModuloRiepilogo = true;
			else if (key == 'contratto_di_servizio') this.downloadingContrattoDiServizio = true;
			axios.post('/api/storage/download',
				{
				path: path
			},
				{
				responseType: 'blob'
			})
				.then(response => {
					saveAs(response.data, fileName);
				})
				.finally(() => {
					if (key == 'modulo_codice_clickday') this.downloadingModuloCodiceClickday = false;
					else if (key == 'modulo_riepilogo') this.downloadingModuloRiepilogo = false;
					else if (key == 'contratto_di_servizio') this.downloadingContrattoDiServizio = false;
				})
		},
		setFileChanged(file) {
			if (file !== null && !this.isLoading) file.changed = true;
		},
		onContrattoDiServizioClear() {
			this.pratica.contratto_di_servizio.path_contratto_di_servizio = null;
			this.pratica.contratto_di_servizio_id = null;
			this.pratica.contratto_di_servizio = Object.assign({}, this.praticaVoid.contratto_di_servizio);
			this.$emit('update-fase-2-key');
			this.$emit('update-fase-8-key');
			this.$emit('update-fase-9-key');
		},
		downloadAllFiles() {
			if (this.pratica.path_modulo_codice_clickday) {
				this.download(this.pratica.path_modulo_codice_clickday, 'modulo_codice_clickday');
			}

			if (this.pratica.path_modulo_riepilogo) {
				this.download(this.pratica.path_modulo_riepilogo, 'modulo_riepilogo');
			}

			if (this.pratica.contratto_di_servizio.path_contratto_di_servizio) {
				this.download(this.pratica.contratto_di_servizio.path_contratto_di_servizio, 'contratto_di_servizio');
			}
		},
    estraiESalvaDatiDalModuloDiRiepilogoSulDB(praticaId, pathModuloRiepilogo, forzaSalvataggioPartitaIvaCodiceFiscale = false) {
      this.isLoadingeEstraiESalvaDatiDalModuloDiRiepilogoSulDB = true;
      axios.post('/api/pratiche/salva-sul-db-i-dati-estratti-dal-modulo-di-riepilogo', {
        pratica_id: praticaId,
        path_modulo_riepilogo: pathModuloRiepilogo,
        forza_salvataggio_partita_iva_codice_fiscale: forzaSalvataggioPartitaIvaCodiceFiscale
      })
        .then((response) => {
          if (response.data.duplicato) {
            this.duplicatoPartitaIvaInfo = {
              partita_iva_codice_fiscale: response.data.partita_iva_codice_fiscale,
              custom_ids_pratiche_duplicate: response.data.custom_ids_pratiche_duplicate
            };
            this.praticaIdInAttesaDiConfermaEstrazione = praticaId;
            this.pathModuloRiepilogoInAttesaDiConfermaEstrazione = pathModuloRiepilogo;
            this.dialogDuplicatoPartitaIva = true;
          } else {
            this.$emit('dati-estratti-dal-modulo-riepilogo-salvati');
          }
        })
        .finally(() => {
          this.isLoadingeEstraiESalvaDatiDalModuloDiRiepilogoSulDB = false;
        });
    },
    confermaEstrazioneDatiModuloRiepilogo() {
      this.dialogDuplicatoPartitaIva = false;
      this.estraiESalvaDatiDalModuloDiRiepilogoSulDB(
        this.praticaIdInAttesaDiConfermaEstrazione,
        this.pathModuloRiepilogoInAttesaDiConfermaEstrazione,
        true
      );
    },
    estraiESalvaCodiceIdentificativoDalModuloCodiceClickdaySulDB(praticaId, pathModuloCodiceClickday) {
      this.isLoadingeEstraiESalvaCodiceIdentificativoDalModuloCodiceClickdaySulDB = true;
      axios.post('/api/pratiche/salva-sul-db-il-codice-identificativo-estratto-dal-modulo-codice-clickday', {
        pratica_id: praticaId,
        path_modulo_codice_clickday: pathModuloCodiceClickday
      })
        .then(() => {
          this.$emit('codice-identificativo-estratto-dal-modulo-codice-clickday-salvato');
        })
        .finally(() => {
          this.isLoadingeEstraiESalvaCodiceIdentificativoDalModuloCodiceClickdaySulDB = false;
        });
    }
	}

}
</script>

<style scoped>

</style>
